<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="top-block">
        <img class="crescent-img slicing" src="@/assets/img/crescent.png" />
        <img class="crown-img slicing" src="@/assets/img/crown.png" />
        <img class="title-img slicing" src="@/assets/img/rank_title.png" />
        <div class="top-goods-wrp">
          <div class="top-goods-box">
            <GoodsItem
              @clickRightArrow="
                navigateTo(`/agentRank/selectGoods?rankType=${postListParams.rankType}&goodsIds=${goodsIds}`)
              "
              class="top-goods-bar"
              v-bind="{
                goodsId: firstGoodsId,
                goodsCoverSize: 60,
                hasRightArrow: true,
                ...goodsState
              }"
            />
            <div class="view-goods-row" v-if="goodsIds.length > 1">
              (已选{{ goodsState.goodsCount }}件商品)&nbsp;&nbsp;<span
                @click="navigateTo(`/agentRank/selectedGoods?goodsIds=${goodsIds}`)"
                class="view-btn"
                >查看</span
              >
            </div>
          </div>
        </div>
      </div>
      <van-sticky>
        <TabBarWrp class="tab-bar">
          <van-tabs
            :color="primaryColor"
            line-width="28px"
            :title-inactive-color="blackColor6"
            :title-active-color="primaryColor"
            v-model:active="postListParams.rankType"
            @click-tab="onClickTab"
            :shrink="rankTypeColum.length > 3"
          >
            <van-tab v-for="item in rankTypeColum" :name="item.key" :key="item.key">
              <template #title>
                <div class="relative px-20px">
                  {{ item.title }}
                  <van-icon
                    v-if="item.helpMessage"
                    class="!absolute top-3px right-0"
                    name="question-o"
                    @click.stop="showDialog({ message: item.helpMessage, confirmButtonText: '好的' })"
                  />
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </TabBarWrp>
        <div class="date-range-bar">
          <DateRangePicker @search="setTime" :days="365" class="date-range-picker" />
          <img
            class="icon"
            v-if="hasNeedScreenLevelList"
            @click="toggleScreen(true)"
            src="@/assets/img/scree_icon.png"
          />
        </div>
      </van-sticky>
      <div class="list-wrp">
        <template v-if="!isShowSingleRank">
          <van-row class="list-title">
            <van-col
              :style="{ textAlign: item.align }"
              v-for="(item, index) in listColum"
              :span="item.span"
              :key="index"
              >{{ item.title }}</van-col
            >
          </van-row>
          <div class="van-hairline--bottom"></div>
          <div class="list-box">
            <van-list
              :immediate-check="false"
              v-model:loading="loading"
              :finished="finished"
              :finished-text="finishedText"
              @load="getList"
            >
              <RankListItem
                v-for="item in list"
                :rankType="postListParams.rankType"
                v-bind="item"
                :agentInfo="item"
                :key="item.puid"
                :spans="listColum.map(d => d.span)"
                class="rank-list-item"
              />
            </van-list>
            <van-empty
              image-size="240"
              image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
              v-if="list.length == 0 && !loading"
              description="暂无数据"
            />
          </div>
        </template>

        <div v-else class="personal-show-box">
          <template v-for="(item, index) in selfRankColum" :key="index">
            <div class="item-box">
              <span class="value not-on-rank" v-if="userSelfRankInfo.isOnRank === 0 && item.key === 'rank'"
                >未上榜</span
              >
              <span class="value" v-else>{{ userSelfRankInfo[item.key] }}</span>
              <div class="label">{{ item.label }}</div>
            </div>
            <div v-if="index === 0" class="van-hairline--right"></div>
          </template>
        </div>
        <div class="fixed-bottom-rank" v-if="!isShowSingleRank && userSelfRankInfo.puid">
          <RankListItem
            showPlace="bottom"
            :rankType="postListParams.rankType"
            v-bind="userSelfRankInfo"
            :agentInfo="userSelfRankInfo"
            :spans="Number(userSelfRankInfo.diffValue) ? [4, 10, 10] : [6, 12, 6]"
          />
        </div>
        <RightSideScreen
          @screen="handleSideScreen"
          @reset="handleSideReset"
          v-model:show="showRightSideScreen"
          :screen-filed="screenFiled"
        />
        <back-top />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
import { useCssVar } from '@vueuse/core'
import { useRouter } from 'vue-router'
import { useToggle } from '@vant/use'
import { getGoodsSimpleList } from '@/api/goods/'
// import { getAgentOverview } from '@/api/home'
import { useUserStore } from '@/store/user'
import { getAgentRankList, getRankSetting } from '@/api/agentRank'
import { Toast } from '@vant/compat'
import { useAgentLevel } from '@/hooks/useBusiness'
import { DateRangePicker, RightSideScreen, TabBarWrp, BackTop } from '@/components'
import { RankListItem, GoodsItem } from './component'
import { tabColum, listTitleColum } from './agentRank.data'
import usePage from '@/hooks/usePage'
// import { getLocal } from '@/common/js/utils'
import { transPxToRem } from '@/utils'
import { showDialog } from 'vant'

const { agentLevelList } = useAgentLevel()
const { navigateTo } = usePage()
const router = useRouter()
const { currentRoute } = router
const query = currentRoute.value.query
const goodsIds = query?.goodsIds ? query?.goodsIds.split(',') : []
const firstGoodsId = goodsIds ? goodsIds[0] : 0
const hasMultipleGoods = goodsIds.length > 1
const topBlockHeight = hasMultipleGoods ? transPxToRem(265) : transPxToRem(214)
const defaultRankType = Number(query.rankType) || tabColum[0].key
const defaultRankShowType = 1 //1代表只显示本人的排名
const defaultRankShowLevel = 1 //1代表只显示本人级别与本人以下级别的代理排行
const goodsState = reactive({
  goodsImage: '',
  goodsName: '',
  goodsPrice: 0,
  goodsCount: goodsIds ? goodsIds.length : 0
})
const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const postListParams = reactive({
  rankType: defaultRankType,
  startTime: '',
  endTime: ''
})

const levelList = ref([])
const userSelfRankInfo = ref({})
const agentShowType = ref(defaultRankShowType)
const needShowRankTypes = ref([])
const refreshing = ref(false)
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const screenFiled = ref([
  {
    key: 'level',
    label: '代理级别',
    filedType: 'tag',
    value: levelList,
    options: agentLevelList,
    selectType: 'checkBox'
  }
])
const hasNeedScreenLevelList = computed(() => agentLevelList.value.length > 1) //只有一级就不用筛查啦
const isShowSingleRank = computed(() => agentShowType.value === defaultRankShowType)
const rankTypeColum = computed(() => tabColum.filter(d => needShowRankTypes.value.includes(d.key)))
const rankName = computed(() => listTitleColum.filter(d => postListParams.rankType === d.key)[0].title)
const selfRankColum = computed(() => [
  { label: '我的排名', key: 'rank' },
  { label: rankName.value, key: 'typeValue' }
])
const listColum = computed(() => listTitleColum.filter(d => ['rank', 'user', postListParams.rankType].includes(d.key)))
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))
const [showRightSideScreen, toggleScreen] = useToggle()

const reset = () => {
  pageParams.page = 1
  list.value = []
  finished.value = false
}

const search = () => {
  reset()
  getList()
}

const setTime = ({ startDate, endDate }) => {
  postListParams.startTime = startDate
  postListParams.endTime = endDate
  search()
}

const onLoad = async () => {
  Toast.loading({ message: '加载中...', orbidClick: true })
  await getGoodsInfo()
  await getRankSetInfo()
}

const handleSideScreen = () => {
  toggleScreen(false)
  search()
}

const handleSideReset = () => {
  levelList.value = []
  handleSideScreen()
}

const onClickTab = () => {
  search()
}

const userStore = useUserStore()
const userInfo = computed(() => userStore.getUserInfo) //用户信息
const getRankSetInfo = async () => {
  try {
    loading.value = true
    const { rankType, agentShowType: showType, agentShowLevel } = await getRankSetting()
    needShowRankTypes.value = rankType
    agentShowType.value = showType
    if (agentShowLevel === defaultRankShowLevel) {
      // const {
      //   userInfo: { level: selfLevel }
      // } = await getAgentOverview()
      // selfLevel userInfo
      agentLevelList.value = agentLevelList.value.filter(d => d.value >= Number(userInfo.value.agentInfo.agentLevel))
    }
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}

const getList = async () => {
  try {
    const { startTime, endTime, rankType } = postListParams
    const params = {
      goods_id: goodsIds,
      start_date: startTime,
      end_date: endTime,
      agent_level: levelList.value,
      rank_type: rankType,
      ...pageParams
    }
    loading.value = true
    const { list: resList, userRankInfo, total } = await getAgentRankList(params)
    userSelfRankInfo.value = userRankInfo
    list.value.push(...resList)
    pageParams.page++
    finished.value = list.value.length === Number(total)
  } catch (e) {
    finished.value = true
    console.log(e)
  } finally {
    loading.value = false
  }
}

const getGoodsInfo = async () => {
  try {
    const resData = await getGoodsSimpleList({ goodsIds, page: 1, pageSize: 1 })
    if (goodsIds.length) {
      const { goodsName, goodsPic, salePrice } = resData.list[0]
      goodsState.goodsName = goodsName
      goodsState.goodsImage = goodsPic
      goodsState.goodsPrice = salePrice
    } else {
      goodsState.goodsCount = resData.total
    }
  } catch (e) {
    console.log(e)
  }
}

const onRefresh = async () => {
  refreshing.value = true
  try {
    postListParams.rankType = defaultRankType
    await onLoad()
    search()
  } finally {
    refreshing.value = false
  }
}

const primaryColor = useCssVar('--van-primary-color', document.documentElement)
const blackColor6 = useCssVar('--van-black-6', document.documentElement)
// const theme = computed(() => userStore.getTheme)

onMounted(onLoad)
</script>
<style lang="less" scoped>
.top-block {
  height: v-bind(topBlockHeight);
  background-image: linear-gradient(to bottom, #ebc386, #e2b972);
  position: relative;
  .slicing {
    position: absolute;
  }
  .crescent-img {
    top: -30px;
    left: -10px;
    width: 61px;
  }
  .crown-img {
    top: 0px;
    right: 0;
    width: 219px;
  }
  .title-img {
    width: 131px;
    height: 67px;
    top: 40px;
    left: 16px;
  }
  .top-goods-wrp {
    position: absolute;
    width: 100%;
    bottom: 10px;
    padding: 0 16px;
    .top-goods-box {
      padding: 16px;
      background-color: var(--van-white);
      border-radius: 4px;
      .view-goods-row {
        padding-left: 70px;
        margin-top: 5px;
        font-size: 12px;
        color: var(--van-black-9);
        .view-btn {
          color: var(--van-primary-color);
        }
      }
    }
  }
  .top-goods-bar {
    background-color: var(--van-white);
  }
}

.tab-bar {
  padding-top: 10px;
  :deep(.van-tab) {
    margin-right: 12px;
    &:nth-last-child(2) {
      margin-right: 0px;
    }
  }
}
.date-range-bar {
  display: flex;
  background-color: var(--van-white);
  padding: 12px;
  align-items: center;
  .date-range-picker {
    flex: 1;
  }
  .icon {
    width: 18px;
    height: 16px;
    margin-left: 10px;
  }
}
.list-wrp {
  padding: 16px;
  margin-top: 8px;
  border-radius: 16px 16px 0px 0px;
  background-color: var(--van-white);
  font-size: 14px;
  .list-title {
    padding: 0 8px;
    margin-bottom: 13px;
    text-align: center;
    color: #666;
  }
  .list-box {
    padding-top: 10px;
    padding-bottom: 60px;
    .rank-list-item {
      padding: 10px 8px;
    }
  }
}

.personal-show-box {
  background-color: var(--van-white);
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 20px 0;
  .item-box {
    flex: 1;
    font-size: 14px;
    color: var(--van-black-6);
    .value {
      font-size: 20px;
      color: var(--van-black-2);
    }
    // .not-on-rank {
    //   font-size: 14px;
    // }
  }
}
.fixed-bottom-rank {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 16px;
  background: var(--van-white);
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.08);
}
</style>
